import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { api, podatki } from '../api/odjemalec';
import { useProdaja } from '../seja/paket';
import { usePravica } from '../seja/pravice';
import { uskladiPush } from './push';

/** Oznaka in barva stanja povpraševanja (NOVO / PREBRANO / RESENO). */
export function stanjePovprasevanja(stanje: string | undefined): { naziv: string; barva: string } {
  switch (stanje) {
    case 'NOVO':
      return { naziv: 'novo', barva: 'red' };
    case 'RESENO':
      return { naziv: 'rešeno', barva: 'green' };
    default:
      return { naziv: 'odprto', barva: 'yellow' };
  }
}

/**
 * Število novih in odprtih povpraševanj (števec v meniju), osveženo vsako minuto in ob vrnitvi na zavihek. Brez modula
 * Prodaja ga ni.
 */
export function useSteviloPovprasevanj() {
  const ponudba = usePravica('PONUDBA');
  const prodaja = useProdaja() && ponudba;
  return useQuery({
    queryKey: ['povprasevanja-stevilo'],
    queryFn: ({ signal }) => podatki(api.GET('/api/povprasevanja/stevilo', { signal })),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    enabled: prodaja,
  });
}

/**
 * V okviru prijavljene aplikacije: klik na push obvestilo (sporočilo iz service workerja) odpre podrobnosti brez
 * ponovnega nalaganja; obstoječo naročnino brskalnika uskladi s strežnikom.
 */
export function usePushVOkviru() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }
    const ob = (e: MessageEvent) => {
      const d = e.data as { vrsta?: string; pot?: string } | null;
      if (d?.vrsta === 'odpri' && d.pot?.startsWith('/')) {
        void navigate(d.pot);
      }
    };
    navigator.serviceWorker.addEventListener('message', ob);
    void uskladiPush().catch(() => undefined);
    return () => navigator.serviceWorker.removeEventListener('message', ob);
  }, [navigate]);
}

/** »1 novo«, »2 novi«, »3 nova«, »5 novih« (dvojina in množina). */
export function novih(n: number): string {
  const d = n % 100;
  return `${n} ${d === 1 ? 'novo' : d === 2 ? 'novi' : d === 3 || d === 4 ? 'nova' : 'novih'}`;
}
